import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { postGeneralData, SupplierPurchaseDetails, UpdatePaymentComplete, updatePurchaseCredit, UpdatePurchasepayment } from "../../../Utility/Api";
import { Pagination } from "../../Common/Functions";
import { toast } from "react-toastify";
import { WarehouseContext } from "../../../Utility/UserContext";
import { getFormattedCurrentDate2, handleCreateAssets, NaviGate, onReqCreatePayment, shop_id } from "../../../Utility/function";

const SupplierDetails1 = () => {
  const navigate = useNavigate();
  const { showLoader, hideLoader, UserItem, shopItem } = useContext(WarehouseContext);
  const [purchases, setPurchases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 10;
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const supplier = location.state?.supplier;
  const supplierId = searchParams.get("supplier_id");
  const [invoiceData, setInvoiceData] = useState([]);
  const [Paymentvalue, setPaymentvalue] = useState();
  const [pamentsModel, setpamentsModel] = useState(false);
  const [payAmount, setPayAmount] = useState(0);
  const [cashAmount, setCashAmount] = useState('');
  const [cardAmount, setCardAmount] = useState('');

  useEffect(() => {
    if (supplierId) {
      fetchSupplierDetails(supplierId, 1);
    }
  }, [supplierId]);

  const fetchSupplierDetails = async (id, page) => {
    setLoading(true);
    setError("");

    try {
      const response = await SupplierPurchaseDetails(id, shop_id);
      if (response.data && response.data.data) {
        setPurchases(response.data.data);
        setTotalPages(response.data.pagination.total_pages);
      } else {
        setError("No purchase details found.");
      }
    } catch (err) {
      setError("Error fetching supplier purchase details.");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // payment model 
  const Handlepaymentmodel = (supplier) => {
    setPaymentvalue(supplier);
    setpamentsModel(true);
    setPayAmount(0);
    setCashAmount(0);
    setCardAmount(0);
  };

  const onHandlePayCredit = async (cashAmount, cardAmount) => {
    try {
      showLoader();
      if (!Paymentvalue?.purchase_id) {
        toast.error("Invalid purchase details");
        hideLoader();
        return;
      }
      const cash = parseFloat(cashAmount || 0);
      const card = parseFloat(cardAmount || 0);

      var paydata = {
        orderID: Paymentvalue?.po,
        date: getFormattedCurrentDate2(),
        amount: "0",
        total_amount: Paymentvalue.total_amount,
        cash: cash,
        credit: 0,
        card: card,
        type: 1,
        mop: "0",
        complete: "1",
      }

      if (cashAmount && cardAmount) {
        paydata.cash = cashAmount;
        paydata.card = cardAmount;
        paydata.mop = "1,4";
      } else if (cashAmount) {
        paydata.cash = cashAmount;
        paydata.mop = "1";
      } else if (cardAmount) {
        paydata.card = cardAmount;
        paydata.mop = "4";
      }
      if (remainingAmount > 0) {
        paydata.credit = remainingAmount;
        paydata.mop = paydata.mop + ",2";
        paydata.complete = "0";
      }

      await onReqCreatePayment(paydata);
      try {
        const generalDataPayload = {
          type: "2",
          ref_id: Paymentvalue?.po,
          remarks: "Purchase",
          date: getFormattedCurrentDate2(),
          created_by: UserItem?.user_id,
          shop_id: shopItem?.id || "0",
          amount: parseFloat(cashAmount || 0) + parseFloat(cardAmount || 0),
          is_debit: "1",
        };
        // await postGeneralData(generalDataPayload);

        const generalDataPayload1 = {
          type: "2",
          ref_id: Paymentvalue?.po,
          remarks: "Bank - To supplier",
          date: getFormattedCurrentDate2(),
          created_by: UserItem?.user_id,
          shop_id: shopItem?.id || "0",
          amount: parseFloat(cashAmount || 0) + parseFloat(cardAmount || 0),
          is_debit: "0",
        };
        await postGeneralData(generalDataPayload1);

        if (paydata?.complete == "0") {
          const generalDataPayload = {
            type: "7",
            ref_id: Paymentvalue?.po,
            remarks: "Purchase Credit",
            date: getFormattedCurrentDate2(),
            created_by: UserItem?.user_id,
            shop_id: shopItem?.id || "0",
            amount: remainingAmount,
            is_debit: "0",
          };
          await postGeneralData(generalDataPayload);
        } else {
          const paymentCompleted = {
            type: "7",
            shop_id: shopItem?.id || "0",
            ref_id: Paymentvalue?.po,
          }
          await UpdatePaymentComplete(paymentCompleted);
        }
      } catch (e) {
        console.error("General log failed:", e);
        toast.error("Failed to create general transaction log");
      }
      await fetchSupplierDetails(supplierId, 1);
      toast.success("Payment successfully");
      setpamentsModel(false);
      setPayAmount(0);
      setCashAmount(0);
      setCardAmount(0);
      hideLoader();
    } catch (error) {
      console.error("Error updating payment:", error);
      toast.error("Error processing payment. Please try again.");
      hideLoader();
    }
  };

  const dueAmount = parseFloat(Paymentvalue?.remaining || 0);
  const totalPayment = parseFloat(cashAmount || 0) + parseFloat(cardAmount || 0);
  const remainingAmount = dueAmount - totalPayment;

  const handleCashChange1 = (e) => {
    let value = parseFloat(e.target.value || 0);
    if (value + parseFloat(cardAmount || 0) > dueAmount) return;
    setCashAmount(value);
  };

  const handleCardChange1 = (e) => {
    let value = parseFloat(e.target.value || 0);
    if (value + parseFloat(cashAmount || 0) > dueAmount) return;
    setCardAmount(value);
  };

  const handleCashChange = (e) => {
    let value = e.target.value;
  
    // allow empty (user erased all digits)
    if (value === "") {
      setCashAmount("");
      return;
    }
  
    // allow only numbers
    if (!/^\d+$/.test(value)) return;
  
    const numericValue = parseFloat(value);
  
    // prevent overpayment
    if (numericValue + parseFloat(cardAmount || 0) > dueAmount) return;
  
    setCashAmount(value);
  };
  const handleCardChange = (e) => {
    let value = e.target.value;
  
    if (value === "") {
      setCardAmount("");
      return;
    }
  
    if (!/^\d+$/.test(value)) return;
  
    const numericValue = parseFloat(value);
  
    if (numericValue + parseFloat(cashAmount || 0) > dueAmount) return;
  
    setCardAmount(value);
  };
  

  return (
    <div className="page-wrappers">
      <div className="page-content">
        <NaviGate />
        <h5 className="mb-0 text-uppercase">Supplier Name :{supplier.supplier_name}</h5>
        <hr />

        <div className="card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-striped table-sm table-bordered align-baseline">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Purchase No</th>
                    <th>Due Amount</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {purchases.length > 0 ? (
                    purchases.map((purchase, index) => (
                      <tr key={purchase.purchase_id}>
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td>{purchase.po}</td>
                        <td>{Number(purchase.remaining).toFixed(3)}</td>
                        <td>
                          <div className="d-flex justify-content-center gap-2 align-items-center">
                            {(purchase?.purchase_unit == 1 || parseFloat(purchase?.remaining || 0) <= 0) ?
                              <button className="btn btn-success btn-sm w-50" disabled>
                                Paid
                              </button>
                              :
                              <button
                                className="btn btn-warning  btn-sm w-50"
                                onClick={() => { Handlepaymentmodel(purchase) }}>
                                Pay
                              </button>
                            }
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        </div>

        {/* payment model  */}
        <div className="modal fade show" style={{ display: pamentsModel ? "block" : "none" }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content p-3" style={{ borderRadius: "12px", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)" }}>
              {/* Modal Header */}
              <div className="modal-header border-0">
                <h4 className="modal-title fw-bold" style={{ fontFamily: "Poppins" }}>
                  Payment Details
                </h4>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setpamentsModel(false)}
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body">
                <div className="p-3 bg-light rounded ">
                  <p className="mb-2 text-start">
                    Order ID: <span className="fw-bold">{Paymentvalue?.po}</span>
                  </p>
                  <p className="mb-2 text-start">
                    <span>Supplier Name:</span>
                    <span className="fw-bold"> {Paymentvalue?.supplier_name}</span>
                  </p>
                  <hr />
                  <div className="">
                    <p className="mb-2 d-flex justify-content-between">
                      <span className="">Amount:</span>
                      <span className="text-primary fw-bold">{Number(Paymentvalue?.total_amount).toFixed(3)}</span>
                    </p>
                    <p className="mb-2 d-flex justify-content-between">
                      <span className="">Due Amount:</span>
                      <span className="text-danger fw-bold">{Number(Paymentvalue?.remaining || '00').toFixed(3)}</span>
                    </p>

                    <p className="mb-2 d-flex justify-content-between align-items-center">
                      <span>Cash:</span>
                      <input
                        type="number"
                        className="form-control text-end w-25"
                        value={cashAmount}
                        onChange={(e) => handleCashChange(e)}
                      />
                    </p>
                    <p className="mb-2 d-flex justify-content-between align-items-center">
                      <span>Card:</span>
                      <input
                        type="number"
                        className="form-control text-end w-25"
                        value={cardAmount}
                        onChange={(e) => handleCardChange(e)}
                      />
                    </p>

                  </div>
                  <hr />
                  <p className="mb-0 fw-bold fs-5 text-end">
                    Remainig Amount:
                    {/* <span className="text-success fw-bold"> {((payAmount || 0) - (Paymentvalue?.remaining || 0))?.toFixed(3)}</span> */}
                    <span className="text-success fw-bold">                     {remainingAmount.toFixed(3)}
                    </span>


                  </p>
                </div>
              </div>

              {/* Modal Footer */}
              <div className="modal-footer border-0 d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-secondary me-2"
                  onClick={() => setpamentsModel(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-success"
                  disabled={
                    totalPayment <= 0 ||
                    totalPayment > parseFloat(Paymentvalue?.remaining || 0)
                  }
                  onClick={() => onHandlePayCredit(cashAmount, cardAmount)}
                >
                  Pay Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplierDetails1;
